<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <!-- <v-img
          src="./../../assets/images/Mask Group 15/Mask Group 15.png"
          height="400px"
        > -->
        
        <!-- </v-img> -->
        <v-img src="./../../assets/images/Web/Rectanglenew.png"></v-img>
          <v-layout justify-center wrap py-10>
            <v-flex xs11 sm11 md9 lg3 xl3 pl-xs-2>
              <span
                :class="$vuetify.breakpoint.name == 'xs' ? 'headxs' : 'head'"
                >We project the futuristic vision of smart enterprising</span
              >
              <!-- <br />
              <span
                :class="$vuetify.breakpoint.name == 'xs' ? 'headxs' : 'head'"
                >vision of smart enterprising</span
              > -->
            </v-flex>
            <v-flex xs4 lg3 xl3>
                <span
                :class="$vuetify.breakpoint.name == 'xs' ? 'head1xs' : 'head1'"
                >Our service aim to reach to the Micro to medium <br />
                sized enterprises in their ever increasing need <br />
                of Data Management.</span
              >
              <v-layout justify-start wrap pt-10>
                <v-flex xs4 sm2 md2 pt-10 pt-sm-0 pt-md-0 pt-lg-0 pt-xl-10>
              <v-btn tile style="text-transform: none" color="#008FDB">
                <span style="color: white; font-family: ibmplexsansregular">
                  Know More
                </span>
                <v-icon color="white" small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-flex>
              </v-layout>
            </v-flex>
             <v-flex xs4 lg3 xl3>
                <span
                :class="$vuetify.breakpoint.name == 'xs' ? 'head1xs' : 'head1'"
                >Our service aim to reach to the Micro to medium <br />
                sized enterprises in their ever increasing need <br />
                of Data Management.</span
              >
            </v-flex>
            
          </v-layout>
          <v-layout justify-center wrap pt-5>
            <!-- <v-flex xs11 sm9 md7 lg7 text-center text-justify>
              <span
                :class="$vuetify.breakpoint.name == 'xs' ? 'head1xs' : 'head1'"
                >Our service aim to reach to the Micro to medium <br />
                sized enterprises in their ever increasing need <br />
                of Data Management.</span
              >
            </v-flex> -->
            
          </v-layout>
        <Services />
        <Servicesection2 />
        <Aboutus />
        <CustomerStories />
        <Blog />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Services from "./../../components/Home/services";
import Servicesection2 from "./../../components/Home/servicesection2";
import Aboutus from "./../../components/Home/aboutUs";
import CustomerStories from "./../../components/Home/customerStories";
import Blog from "./../../components/Home/blog";
export default {
  components: {
    Services,
    Servicesection2,
    Aboutus,
    CustomerStories,
    Blog,
  },

  data: () => ({
    //
  }),
};
</script>